import React from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'

import { Segment } from 'semantic-ui-react'

import Statistics from 'Components/StatisticsSegment/Statistics'

import { THEME_COLOR } from 'Global/constants'

const StatisticsSegment = ({ statistics }) =>
  !isEmpty(statistics) ? (
    <Segment color={THEME_COLOR}>
      <Statistics statistics={statistics} />
    </Segment>
  ) : null

StatisticsSegment.propTypes = {
  statistics: PropTypes.object.isRequired,
}

export default StatisticsSegment
